import { useEffect, useState } from 'react';
// import { MultiViewer /* , Viewer */ } from 'react-iiif-viewer';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import { MultiViewer } from '../../custom/Viewers/src';
import PanoramaViewer from '../../custom/Viewers/PanoramaViewer';
import ReversePanoramaViewer from '../../custom/Viewers/ReversePanoramaViewer';
// import useLocales from '../../../hooks/useLocales';
import Iconify from '../../Iconify';
import './CultureObject.css';
import Video2Viewer from '../../custom/Viewers/Video2Viewer';
import AudioViewer from '../../custom/Viewers/AudioViewer';
import X3DViewer from '../../custom/Viewers/X3DViewer';
import VRVideoViewer from '../../custom/Viewers/VRVideoViewer';
import DownloadViewer from '../../custom/Viewers/DownloadViewer';

DigitalPreview.propTypes = {
  preview: PropTypes.any,
};

export default function DigitalPreview({ preview }) {
  // const { translate } = useLocales();
  const [output, setOutput] = useState(null);

  useEffect(() => {
    let tempOutput = null;
    switch (preview?.type) {
      case 'OBJECT_PANORAMA':
        tempOutput = <ReversePanoramaViewer preview={preview} />;
        break;
      case 'SPHERICAL_PANORAMA':
        tempOutput = <PanoramaViewer preview={preview} />;
        break;
      case 'VIDEO':
        tempOutput = <Video2Viewer preview={preview} />;
        break;
      case '3D_VIDEO':
        tempOutput = <VRVideoViewer preview={preview} />;
        break;
      case 'AUDIO':
        tempOutput = <AudioViewer preview={preview} />;
        break;
      case 'IMAGES':
      case 'images':
        tempOutput = <MultiViewer width="100%" iiifUrls={preview.images.map((img) => `${img.full.iiifUrl}`)} />;
        break;
      case 'BOOK':
        tempOutput = <MultiViewer width="100%" iiifUrls={preview.pages.map((page) => `${page.full.iiifUrl}`)} />;
        break;
      case '3D_MODEL':
        tempOutput = <X3DViewer preview={preview} />;
        break;
      case 'DOWNLOAD':
        tempOutput = <DownloadViewer preview={preview} />;
        break;
      default:
        tempOutput = (
          <div className="preview-box">
            <span className="preview-loading">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center', // Add this line to align the content vertically

                  textAlign: 'center',
                  lineHeight: '100%',
                }}
              >
                <Iconify icon="eos-icons:three-dots-loading" color="#ffc425" width={44} height={44} />
              </Box>
            </span>

            {/* <span className="not-available">{translate('preview.noPreview')}</span> */}
          </div>
        );
    }
    setOutput(tempOutput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview]);

  useEffect(() => {
    const elements = document.querySelectorAll('[data-testid=fullscreen-controls]');
    elements.forEach((item) => {
      item.style.color = 'black';
      item.style.top = 'unset';
      item.style.bottom = '60px';
      item.style.left = 'unset';
      item.style.right = '10px';
    });

    const elements2 = document.querySelectorAll('[data-testid=drawer]');
    elements2.forEach((item) => {
      item.style.width = 'auto';
      item.style.transition = 'top 0s ease-in 0s';
    });
  });

  return <>{output}</>;
}
